export default __webpack_public_path__ + "static/media/chalkboard__bg.e2e408cf.jpg";